import axios from './HTTP'

export default {
  getInitialData (callback) {
    axios
      .get('/api/menu.json')
      .then(response => ( callback(response.data) ))
      .catch(error => {
        errorCallback(error)
      })
  //#     menuData: {
  //#       messages: [
  //#         "Any message you like can go here",
  //#         "Will rotate through list of actual messages"
  //#       ],
  //#       employeeName: @current_user.name,
  //#       hasMail: true,
  //#       hasTasksDue: false,
  //#     }
  },
}
